import { Box, Button, CircularProgress, Typography, } from "@mui/material";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";
import EXIF from "exif-js";

import CameraImg from "../../assets/icons/ic_camera.png";
import { imageContainer, imgButtonContaier, subTitle, } from "./styles";
import { storage } from "../../services/firebase";
import { showToast } from "../../services/toast";
import { ImageType, PictureType } from "../../types";

type Props = {
  webcamType: string;
  title: string;
  // setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  basePath: string;
  defaultImageSrc: string;
  imageSrc: string;
  longitude: number | null;
  latitude: number | null;
  updateSrc: Function;
  saveImage: Function;
  pictureType: PictureType;
  capture: "user" | "environment";

};

// https://www.codefrontend.com/file-upload-reactjs/

const ImageUpload = (props: Props) => {
  const cameraType = props.webcamType;
  const [isUploading, setIsUploading] = useState<boolean>(false);
 


  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      uploadFile(e.target.files[0]);
    }
  };

  const extractExifData = (blob: ArrayBuffer) => {

    const allMetaData = EXIF.readFromBinaryFile(blob);
    // console.log("metadata---->", allMetaData);
    return allMetaData;

  };


  const uploadFile = async (file: File) => {
    setIsUploading(true);
    if (!file) {
      showToast("Please select an image", "error");
      setIsUploading(false);
      return;
    }

    try {
      // Convert data URL to Blob

      const blob = await file.arrayBuffer();
      const meta = extractExifData(blob);
      if (!meta) {
        showToast("Invalid image, please use the phone camera.", "error");
        setIsUploading(false);
        return;
      }
      // console.log("meta", meta);
      const imageRef = storageRef(
        storage,
        `${props.basePath}/${cameraType}.jpg`
      );

      await uploadBytes(imageRef, blob);
      const url = await getDownloadURL(imageRef);
      meta.MakerNote = "";
      meta.UserComment = "";
      meta.BrowserLocation = {
        lat: props.latitude,
        lng: props.longitude,
      };

      const cleanMeta = JSON.parse(JSON.stringify(meta));


      let imageData: ImageType = {
        basePath: `${props.basePath}`,
        createdAt: new Date(),
        name: `${cameraType}/${Date.now()}`,
        size: blob.byteLength,
        thumbUrl: url,
        type: "image/jpg",
        url: url,
        exifdata: cleanMeta,
      };


      props.updateSrc(url);
      await props.saveImage(imageData, props.pictureType)
      console.log(`URL: ${url}`);


      setIsUploading(false);
      // props.setOpen(false);
    } catch (error) {
      setIsUploading(false);
      showToast((error as Error).message, "error");
    }
  };


  // ------------
  // capture="user" for selfie
  // capture="environment" for rear camera
  // ------------
  return (
    <Box sx={(theme) => imageContainer(theme)}>
      <Typography sx={(theme) => subTitle(theme)}>{props.title}</Typography>
      <Box sx={{ position: "relative" }}>
        <img
          src={
            props.imageSrc === "" ? props.defaultImageSrc : props.imageSrc
          }
          style={{
            height: "180px",
            width: "100%",
            objectFit: props.imageSrc === "" ? "contain" : "cover",
          }}
          alt="logo"
        />

        <label>
          <Box sx={(theme) => imgButtonContaier(theme)}>

            <input style={{ display: "none" }} type="file" accept="image/*" capture={props.capture} onChange={handleFileChange} />
            <Box
              sx={{
                backgroundColor: "white",
                marginTop: "-110px",
                height: "80px",
                width: "80px",
                borderRadius: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
              }}
            >
              <img src={CameraImg} width={50} alt="camera" />
            </Box>

          </Box>
        </label>

      </Box>
    </Box>
  );
};

export default ImageUpload;
